import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #FFE5CC;
  border: 1px solid #FF9900;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #FF9900;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #FF9900;
  flex: 1;
`;

const NodeType = styled.div`
  font-size: 10px;
  background: rgba(142, 36, 170, 0.1);
  color: #8e24aa;
  padding: 2px 6px;
  border-radius: 4px;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const NodeDetails = styled.div`
  font-size: 11px;
  color: #777;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailItem = styled.div`
  display: flex;
`;

const DetailLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
`;

const DetailValue = styled.span`
  color: #555;
`;

const OutputNode = ({ data }) => {
  const { label, description, outputType, format, destination } = data;
  
  const outputTypeLabels = {
    response: 'Response',
    file: 'File',
    database: 'Database',
    webhook: 'Webhook'
  };
  
  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />
      
      <NodeHeader>
        <NodeIcon>⏹</NodeIcon>
        <NodeLabel>{label}</NodeLabel>
        {/* <NodeType>{outputTypeLabels[outputType] || 'Output'}</NodeType> */}
      </NodeHeader>
      
      <NodeDescription>{description}</NodeDescription>
      
      <NodeDetails>
        {format && (
          <DetailItem>
            <DetailLabel>Format:</DetailLabel>
            <DetailValue>{format}</DetailValue>
          </DetailItem>
        )}
        
        {outputType !== 'response' && destination && (
          <DetailItem>
            <DetailLabel>Destination:</DetailLabel>
            <DetailValue>{destination}</DetailValue>
          </DetailItem>
        )}
      </NodeDetails>
    </NodeContainer>
  );
};

export default memo(OutputNode);
